import { DefaultTheme } from 'styled-components/macro';
export const theme: DefaultTheme = {
    fonts: {
        primary: {
            family: 'sans-serif',
            size: '16px',
        },
    },
    colors: {
        primary: {
            color: '#ccc',
            backgroundColor: '#222',
        },
        secondary: {
            color: 'white',
            backgroundColor: '#1e3240',
        },
        widgets: {
            color: '#d3531a',
        },
    },
    borders: {
        color: '#444',
        thickness: '3px',
    },
    mainMenu: { width: '200px' },
    headerBar: { height: '70px' },
    footerBar: { height: '40px' },
};
